<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-cart"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="white mx-1">
        <v-row class="d-flex justify-center my-4">
          <v-radio-group
              v-model="row"
              row
              style="background-color: #F3F6F9; padding: 20px 50px 0px 50px"
          >
            <v-radio v-for="(item,index) in status" :key="index"
                     :label="item.name"
                     :value="item.value"
            ></v-radio>
          </v-radio-group>
        </v-row>
        <v-col cols="12" class="px-5">
          <v-col cols="11" class="bold">
            Order ID: {{ orderDetail.id }}
          </v-col>
          <v-col cols="12">
            <v-row class="d-flex ml-2 align-center mb-2">
              <div class="mb-5">
                Customer name:
              </div>
              <v-col
                  cols="4"
              >
                <v-text-field
                    readonly
                    filled
                    v-model="orderDetail.customer_name"
                ></v-text-field>
              </v-col>
            </v-row>

          </v-col>
          <v-col cols="12" class="mt-n10">
            <v-row class="d-flex ml-2 align-center mb-2">
              <div class="mb-5">
                Customer email:
              </div>
              <v-col
                  cols="4"
              >
                <v-text-field
                    filled
                    readonly
                    v-model="orderDetail.customer_email"
                ></v-text-field>
              </v-col>
            </v-row>

          </v-col>
          <v-col cols="12" class="bold mt-n10">
            Total (credit): {{ orderDetail.total_price }}
          </v-col>
          <v-col cols="12" class="mt-n2 mr-5">
            <v-data-table
                :headers="headers"
                :items="list_details"
                :items-per-page="10"
                class="elevation-1"
            >
              <template v-slot:item.template="{ item }">
                {{ item && item.template && item.template.name ? item.template.name : '' }}
              </template>
              <template v-slot:item.photo_url="{ item }">
                <img :src="item && item.photo_url ? item.photo_url :''" class="mt-2" width="100px">
              </template>
              <template v-slot:item.price="{ item }">
                {{ item && item.price ? item.price : 0 }}
              </template>
              <template v-slot:item.size="{ item }">
                <div v-if="item && item.template && item.template.size">
                  <div v-for="(element,index) in  item.template.size" :key="index">
                    {{ element.name }}
                  </div>
                </div>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn class="btn__property">
                  <v-icon>mdi-cloud-upload-outline</v-icon>
                  Upload design
                  <input type="file" accept="image/*" style="opacity: 0; position: absolute;left: 0 ; max-width: 150px"
                         @change="uploadImage($event,item.id)"/>
                </v-btn>
                <a class="a__property mr-5" @click="viewDesign(item.id)" v-if="item.design_url">View design</a>
                <a class="a__property" @click="viewDetail(item.id)">View detail</a>
              </template>
            </v-data-table>
          </v-col>
        </v-col>
      </v-row>
      <v-dialog
          v-model="dialogViewDetail"
          v-if="dialogViewDetail"
          max-width="1000px"
          persistent
      >
        <v-card class="pa-5">
          <v-card-actions>
            <v-row align="center" justify="end" class="mb-3 ">
              <v-btn class="mr-8 btn-cancel" color="#8C8C8C" @click="dialogViewDetail = false">CANCEL</v-btn>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <v-row align="center" justify="center">
              <v-col cols="12">
                <v-row>
                  <v-col class="6">
                    <img :src="photo" width="501" height="621" style="object-fit: contain">
                  </v-col>
                  <v-col class="6">
                    <v-col class="mt-4" cols="12">
                      <div class="d-flex mb-5 mt-n6">
                        <img src="@/assets/note 1.svg">
                        <div class="title">{{ nameTemplate }}</div>
                      </div>
                      <div class="sub_header">
                        <div class="sub_header__text">
                          Size: <span class="font-normal text-[16px]">{{ size.name }}</span>
                        </div>
                        <div class="sub_header_info__text">{{ size.size }}</div>
                      </div>
                      <div class="titleTemplate">Information of poster</div>
                      <div v-for="(item,index) in detailTemplate" :key="index">
                        <div v-if="item.type == 'text' && item.value">
                          <div class="form">
                            <div class="title__text">{{ item.title }}</div>
                            <div class="title-form">{{ item.value }}</div>
                          </div>
                        </div>
                        <div v-if="item.type == 'image' && item.value">
                          <div class="form">
                            <div class="title__text">{{ item.title }}</div>
                            <div class="pt-1"><a :href="item.value" download="" target="_blank">Download</a></div>
                          </div>
                          <div class="mt-4">
                            <img :src="item.value" width="313" height="311" style="object-fit: cover">
                          </div>
                        </div>

                      </div>
                      <div class="flex flex-column">
                        <div class="title__text">Additional information</div>
                        <div class="title-form">{{ information }}</div>
                      </div>
                    </v-col>
                  </v-col>
                </v-row>
              </v-col>

            </v-row>
          </v-card-text>

        </v-card>
      </v-dialog>
      <v-dialog
          v-model="dialogViewDesign"
          v-if="dialogViewDesign"
          max-width="560px"
          persistent
      >
        <v-card class="pa-5">
          <v-card-actions>
            <v-row align="center" justify="end" class="mb-3 ">
              <v-btn class="btn-X" color="#8C8C8C" @click="dialogViewDesign = false">X</v-btn>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <v-row align="center" justify="center">
              <img :src="imageView ? imageView :''" width="501" height="621" style="object-fit: contain">
            </v-row>
            <v-row justify="end">
              <a class="download__text" :href="imageView ?  imageView :''" download="" target="_blank">Download</a>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {GET_DETAIL_ORDER, UPLOAD_IMAGE_DESIGN, UPLOAD_ORDER} from "@/store/modules/order";

export default {
  name: "EditOrder",
  data() {
    return {
      page: "Orders",
      breadcrumbs: [
        {
          text: "Orders",
          disabled: false,
        }, {
          text: "Order detail",
          disabled: true,
        },

      ],
      row: null,
      status: [
        {name: 'Received', value: '0'},
        {name: 'Paid', value: '1'},
        {name: 'Processing', value: '2'},
        {name: 'Completed', value: '3'}],
      headers: [
        {text: "ID", value: "id", align: "start"},
        {text: "Product", value: "template"},
        {text: "Image", value: "photo_url"},
        {text: "Price (Credit)", value: "price"},
        {text: "Size", value: "size"},
        {text: "Actions", value: "actions", sortable: false},
      ],
      dialogViewDetail: false,
      detailTemplate: {},
      nameTemplate: '',
      size: '',
      photo: '',
      list_details: [],
      image: null,
      dialogViewDesign: false,
      imageView: '',
      url: '',
      information: ''
    }
  },
  computed: {
    ...mapGetters({
      orderDetail: "orderDetail",
    })
  },
  watch: {
    orderDetail: {
      immediate: true,
      deep: true,
      handler(val) {
        this.list_details = val.details
      }
    },
    row(newValue, oldValue) {
      if (oldValue != null) {
        this.orderDetail.status = newValue
        this.$store.dispatch(`${UPLOAD_ORDER}`, this.orderDetail).then((data) => {
              if (data.data.status == 1) {
                this.$toasted.success('Cập nhật thành công!', {
                  duration: 1000,
                  position: 'top-center'
                })
              } else {
                alert(data.data.errors)
              }
            }
        )

      }
    },
  },

  async created() {
    await this.$store.dispatch(`${GET_DETAIL_ORDER}`, this.$route.params.id);
    this.url = process.env.VUE_APP_API_URL
    this.row = this.orderDetail.status
  },
  methods: {
    viewDesign(id) {
      this.dialogViewDesign = true
      this.orderDetail.details.forEach((item) => {
        if (item.id == id) {
          this.imageView = item.design_url
        }
      })
    },
    async uploadImage(event, id) {
      this.image = event.target.files[0];
      let form = new FormData();
      form.append("upload", this.image);
      form.append("id", id);
      await this.$store.dispatch(`${UPLOAD_IMAGE_DESIGN}`, form).then((data) => {
            if (data.data.status == 1) {
              this.$toasted.success('Update successful!', {
                duration: 1000,
                position: 'top-center'
              })
              window.location.reload();
            } else {
              alert(data.data.errors)
            }
          }
      )
    },
    viewDetail(id) {
      this.dialogViewDetail = true
      this.orderDetail.details.forEach((item) => {
        if (item.id == id) {
          this.photo = item.photo_url
          this.nameTemplate = item.template.name
          this.detailTemplate = item.form
          this.size = item.template.size
          this.information = item.information
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.download__text {
  margin-top: 5px;
  color: #71BEC8;
  text-decoration: underline;
  text-decoration-color: #71BEC8;
}

.input-image {
  visibility: collapse;
}

.a__property {
  color: #71BEC8;
}

.a__property:hover {
  text-decoration: underline;
}

.btn-cancel {
  color: white;
  border: 1px solid #8C8C8C;
  border-radius: 36px;
  font-size: 14px;
}

.btn-X {
  color: white;
  border: 1px solid #8C8C8C;
  border-radius: 50%;
  font-size: 12px;
  min-width: 30px !important;
  height: 30px !important;
  padding: 0 !important;
}

.btn__property {
  border: #71BEC8;
  border-radius: 36px;
  color: #71BEC8;
  margin-right: 20px;
  position: relative;
}

.title {
  margin-left: 8px;
  color: #565555;
  font-size: 22px;
}

.sub_header {
  margin-top: 5px;
  margin-bottom: 5px;

  .sub_header__text {
    font-size: 18px;
    color: #565555;
  }

  .sub_header_info__text {
    padding-left: 37px;
    font-size: 16px;
    color: #9D9D9D;
  }
}

.titleTemplate {
  color: #565555;
  font-size: 22px;
  font-weight: 500;
  margin-top: 20px;
  margin-bottom: 20px;
}

.form {
  display: flex;

  .title__text {
    color: #9D9D9D;
    font-size: 16px;
    margin-right: 10px;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .title-form {
    padding-top: 5px;
    color: #565555;
    font-size: 16px;
  }

  a {
    color: #71BEC8;
    font-size: 16px;
    text-decoration: underline;
    font-weight: 500;
  }
}

</style>